import React, { useState, useRef, useEffect } from 'react';
import { FiFileText, FiChevronDown, FiAlertCircle } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { applyAdvanceLeave, resetLeaveFormState } from '../../Redux/Slice/LeaveForm';
import Cookies from 'js-cookie';
import { findJuniorDevelopers } from '../../Redux/Slice/TaskMasterSlice';
import ConfirmModal from '../../Components/ConfirmModal/ConfirmModal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../Components/Loader/Loader';

const AdvanceLeave = ({ onBack }) => {

    const loginData = Cookies.get("loginData");
    const parsedData = loginData ? JSON.parse(loginData) : null;
    const applicantUser = parsedData?.data || parsedData?.user || {};
    const loggedInUserId = applicantUser?._id;
    const loggedInUserRole = applicantUser?.Role;
    const today = new Date().toISOString().split('T')[0];
    const sevenDaysFromNow = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];

    const [fromDate, setFromDate] = useState('');
    const [fromDateError, setFromDateError] = useState(false);
    const [toDate, setToDate] = useState('');
    const [toDateError, setToDateError] = useState(false);
    const [outOfStation, setOutOfStation] = useState(false);
    const [cityName, setCityName] = useState('');
    const [cityError, setCityError] = useState(false);
    const [leaveReason, setLeaveReason] = useState('');
    const [leaveReasonError, setLeaveReasonError] = useState(false);
    const [isReasonDropdownOpen, setIsReasonDropdownOpen] = useState(false);
    const [reason, setReason] = useState('');
    const [reasonError, setReasonError] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pendingPayload, setPendingPayload] = useState(null);
    const dropdownRef = useRef(null);

    const dispatch = useDispatch();
    const { loading, success, error } = useSelector((state) => state.LeaveForm);
    const { JuniorDevelopers } = useSelector((state) => state.TaskMaster);

    useEffect(() => {
        dispatch(findJuniorDevelopers());
    }, [dispatch]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsReasonDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    if (loading) {
        return <Loader />;
    }

    const juniorOptions =
        JuniorDevelopers?.data
            ?.filter((junior) => junior?._id !== loggedInUserId)
            ?.map((junior) => ({
                label: junior?.Name,
                Role: junior?.Role,
                _id: junior?._id,
            })) || [];

    const leaveReasonsList = [
        "Personal Work",
        "Medical / Health Issue",
        "Family Emergency",
        "Out of Station Travel",
        "Child Care / School Related Work",
        "Late Arrival / Time Adjustment",
        "Home Emergency",
        "Bereavement / Loss",
        "Child / Family Commitment",
        "Home Relocation / House Work",
        "Examination / Education Purpose",
        "Official External Work",
        "Personal Milestone Event",
        "Government / Official Compliance",
        "Vehicle / Transport Work",
        "Other"
    ];


    const handleSubmit = (e) => {
        e.preventDefault();

        if (!fromDate) {
            setFromDateError(true);
            return;
        }

        if (!toDate) {
            setToDateError(true);
            return;
        }

        if (toDate < fromDate) {
            toast.error("Advance leave requires 7 days notice", { position: "top-right", autoClose: 3000 });
            return;
        }

        if (!leaveReason) {
            setLeaveReasonError(true);
            return;
        }

        if (outOfStation && !cityName.trim()) {
            setCityError(true);
            return;
        }

        if (!reason.trim()) {
            setReasonError(true);
            return;
        }


        try {
            const loginDataStr = Cookies.get("loginData");
            let loginData = null;
            if (loginDataStr) {
                loginData = JSON.parse(loginDataStr);
            }
            const applicantUser = loginData?.data || loginData?.user || {};

            let firstApprover = {
                position: "Senior Developer",
                name: "JAY PARMAR" || "KALPESH DILKHUSH",
                status: "Pending"
            };

            let secondApprover = {
                name: "DIPAK RAJPUT",
                position: "Delphi Senior Developer",
                approverId: "66f7aac08bd6fc731ee1d02f",
                status: "Pending"
            };

            if (applicantUser.Role === "Delphi Junior Developer" || applicantUser.Role === "Delphi Senior Developer") {
                const targetApprover = juniorOptions.find(opt =>
                    opt.Role === "Delphi Senior Developer" &&
                    opt.label && opt.label.toUpperCase().includes("KALPESH")
                ) || juniorOptions.find(opt => opt.Role === "Delphi Senior Developer");

                firstApprover = {
                    position: "Delphi Senior Developer",
                    name: targetApprover ? targetApprover.label : "KALPESH DILKHUSH",
                    approverId: targetApprover ? targetApprover._id : "682c63fe6b35012c7f3a7dd7",
                    status: "Pending"
                };
            } else if (applicantUser.Role === "Web Junior Developer" || applicantUser.Role === "Web Senior Developer") {
                const targetApprover = juniorOptions.find(opt =>
                    opt.Role === "Web Senior Developer" &&
                    opt.label && opt.label.toUpperCase().includes("JAY")
                ) || juniorOptions.find(opt => opt.Role === "Web Senior Developer");

                firstApprover = {
                    position: "Web Senior Developer",
                    name: targetApprover ? targetApprover.label : "JAY PARMAR",
                    approverId: targetApprover ? targetApprover._id : "676bcd353d488c3eeca8291d",
                    status: "Pending"
                };
            }
            else if (applicantUser.Role === "Junior Customer Support") {
                const targetApprover = juniorOptions.find(opt =>
                    opt.Role === "Senior Customer Support" &&
                    opt.label && opt.label.toUpperCase().includes("VIPUL")
                ) || juniorOptions.find(opt => opt.Role === "Senior Customer Support");

                firstApprover = {
                    position: "Senior Customer Support",
                    name: targetApprover ? targetApprover.label : "VIPUL KANTHARIA",
                    approverId: targetApprover ? targetApprover._id : "672b4e1df07347a35c340dfa",
                    status: "Pending"
                };
            }
            else if (applicantUser.Role === "Data Analyst" || applicantUser.Role === "inhouse") {
                // Data Analyst or inhouse: skip firstApprover, go directly to DIPAK RAJPUT → owner
                const approvers = [
                    {
                        name: "DIPAK RAJPUT",
                        position: "Delphi Senior Developer",
                        approverId: "66f7aac08bd6fc731ee1d02f",
                        status: "Pending"
                    },
                    {
                        position: "owner",
                        name: "GOPESH PERIWAL" || "LALIT PERIWAL",
                        status: "Pending"
                    },
                ];

                const payload = {
                    applicantId: applicantUser._id,
                    applicantName: applicantUser.Name,
                    applicantRole: applicantUser.Role,
                    fromDate,
                    toDate,
                    leaveReason,
                    outOfStation,
                    cityName,
                    reason,
                    approvers,
                };

                setPendingPayload(payload);
                setShowConfirmModal(true);
                return; // exit early, skip the default approvers block below
            }

            const approvers = [
                firstApprover,
                secondApprover,
                {
                    position: "owner",
                    name: "GOPESH PERIWAL" || "LALIT PERIWAL",
                    status: "Pending"
                },
            ];

            const payload = {
                applicantId: applicantUser._id,
                applicantName: applicantUser.Name,
                applicantRole: applicantUser.Role,
                fromDate,
                toDate,
                leaveReason,
                outOfStation,
                cityName,
                reason,
                approvers,
            };

            // Store payload and show confirm modal instead of dispatching directly
            setPendingPayload(payload);
            setShowConfirmModal(true);

        } catch (error) {
            console.error("Error applying advance leave:", error);
            toast.error("Error applying advance leave. Please try again.", { position: "top-right", autoClose: 3000 });
        }
    };

    const confirmSubmit = async () => {
        if (!pendingPayload) return;
        setShowConfirmModal(false);
        try {
            const result = await dispatch(applyAdvanceLeave(pendingPayload)).unwrap();
            if (result.status === "Success" || result.success) {
                toast.success("Advance Leave applied successfully!", { position: "top-right", autoClose: 3000 });
                onBack();
            }
        } catch (err) {
            toast.error(err || "Failed to apply advance leave.", { position: "top-right", autoClose: 3000 });
        } finally {
            setPendingPayload(null);
        }
    };

    return (
        <>
            <ConfirmModal
                isOpen={showConfirmModal}
                onClose={() => { setShowConfirmModal(false); setPendingPayload(null); }}
                onConfirm={confirmSubmit}
                title="Submit Leave Request"
                message="Are you sure you want to submit this Advance Leave request? It will be sent for approval."
            />
            <div className="w-full bg-white rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-gray-100 p-4 md:p-5 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50/50 rounded-full -mr-16 -mt-16 -z-0"></div>
                
                <div className="flex flex-col sm:flex-row justify-between items-start mb-10 gap-4 relative z-10">
                    <div className="flex items-center gap-4">
                        <div className="w-12 h-12 rounded-2xl bg-[#133A69] text-white flex items-center justify-center shadow-lg shadow-blue-900/20">
                            <FiFileText className="w-6 h-6" />
                        </div>
                        <div>
                            <h2 className="text-[20px] font-black text-gray-800 tracking-tight">Advance Leave</h2>
                            <p className="text-[13px] text-gray-500 mt-0.5 font-medium">Request your planned time off</p>
                        </div>
                    </div>
                    <button
                        onClick={onBack}
                        type="button"
                        className="text-[12px] font-bold text-[#133A69] hover:bg-blue-50 border-2 border-[#133A69]/10 px-4 py-2 rounded-xl transition-all active:scale-95"
                    >
                        Change Type
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="space-y-8 relative z-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="space-y-2">
                            <label className="block text-[13px] font-bold text-gray-700 ml-1">From Date</label>
                            <div className="relative">
                                <input
                                    type="date"
                                    value={fromDate}
                                    min={today}
                                    onChange={(e) => {
                                        setFromDate(e.target.value);
                                        setFromDateError(false);
                                    }}
                                    className={`w-full bg-[#f8fafc] border-2 ${fromDateError || (fromDate && fromDate < sevenDaysFromNow) ? 'border-red-400 ring-4 ring-red-50' : 'border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50'} rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm`}
                                />
                            </div>
                            {(fromDateError || (fromDate && fromDate < sevenDaysFromNow)) && (
                                <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5 animate-in slide-in-from-left-2">
                                    <FiAlertCircle className="w-3.5 h-3.5" />
                                    {fromDateError ? "Start date is required." : "Advance leave requires 7 days notice."}
                                </p>
                            )}
                        </div>

                        <div className="space-y-2">
                            <label className="block text-[13px] font-bold text-gray-700 ml-1">To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                min={today}
                                onChange={(e) => {
                                    setToDate(e.target.value);
                                    setToDateError(false);
                                }}
                                className={`w-full bg-[#f8fafc] border-2 ${toDateError || (toDate && toDate < fromDate) ? 'border-red-400 ring-4 ring-red-50' : 'border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50'} rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm`}
                            />
                            {(toDateError || (toDate && toDate < fromDate)) && (
                                <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5 animate-in slide-in-from-left-2">
                                    <FiAlertCircle className="w-3.5 h-3.5" />
                                    {toDateError ? "End date is required." : "To date must be after from date."}
                                </p>
                            )}
                        </div>

                        <div className="relative space-y-2" ref={dropdownRef}>
                            <label className="block text-[13px] font-bold text-gray-700 ml-1">Leave Reason Category</label>
                            <div
                                className={`w-full bg-[#f8fafc] border-2 ${leaveReasonError ? 'border-red-400 ring-4 ring-red-50' : isReasonDropdownOpen ? 'border-[#133A69] ring-4 ring-blue-50' : 'border-gray-100 hover:border-gray-200'} rounded-2xl px-5 py-4 text-sm transition-all font-semibold cursor-pointer shadow-sm flex justify-between items-center`}
                                onClick={() => setIsReasonDropdownOpen(!isReasonDropdownOpen)}
                            >
                                <span className={`block truncate ${leaveReason ? 'text-gray-800' : 'text-gray-400'}`}>
                                    {leaveReason || "Select a category"}
                                </span>
                                <FiChevronDown className={`shrink-0 ml-2 transition-transform duration-300 ${isReasonDropdownOpen ? 'rotate-180 text-[#133A69]' : 'text-gray-400'}`} />
                            </div>

                            {leaveReasonError && (
                                <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5">
                                    <FiAlertCircle className="w-3.5 h-3.5" />
                                    Please select a category.
                                </p>
                            )}

                            {isReasonDropdownOpen && (
                                <div className="absolute z-20 w-full mt-2 bg-white border border-gray-100 rounded-[1.5rem] shadow-[0_20px_60px_rgba(0,0,0,0.1)] py-3 max-h-[300px] overflow-y-auto animate-in fade-in zoom-in-95 duration-200" style={{ scrollbarWidth: 'thin' }}>
                                    {leaveReasonsList.map((reasonOpt, idx) => (
                                        <div
                                            key={idx}
                                            className={`px-5 py-3 text-[13px] font-bold cursor-pointer transition-all flex items-center gap-3 ${leaveReason === reasonOpt
                                                ? 'bg-blue-600 text-white'
                                                : 'text-gray-600 hover:bg-blue-50 hover:text-blue-700'
                                                }`}
                                            onClick={() => {
                                                setLeaveReason(reasonOpt);
                                                setLeaveReasonError(false);
                                                setIsReasonDropdownOpen(false);
                                            }}
                                        >
                                            <div className={`w-2 h-2 rounded-full ${leaveReason === reasonOpt ? 'bg-white' : 'bg-gray-200 opacity-0 group-hover:opacity-100'}`}></div>
                                            {reasonOpt}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="flex items-center justify-between bg-[#f8fafc] border-2 border-gray-100 p-5 rounded-2xl shadow-sm self-end h-[60px]">
                            <div>
                                <h3 className="text-[13px] font-bold text-gray-700">Out of Station</h3>
                                <p className="text-[11px] text-gray-500 mt-0.5 font-medium">Traveling abroad/out-of-town?</p>
                            </div>
                            <label className="relative inline-flex items-center cursor-pointer group">
                                <input
                                    type="checkbox"
                                    className="sr-only peer"
                                    checked={outOfStation}
                                    onChange={() => setOutOfStation(!outOfStation)}
                                />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 shadow-inner"></div>
                            </label>
                        </div>
                    </div>

                    {outOfStation && (
                        <div className="animate-in fade-in slide-in-from-top-4 duration-500">
                            <div className="space-y-2">
                                <label className="block text-[13px] font-bold text-gray-700 ml-1">
                                    Station / City Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={cityName}
                                    onChange={(e) => {
                                        setCityName(e.target.value);
                                        if (e.target.value.trim().length > 0) setCityError(false);
                                    }}
                                    placeholder="e.g. Surat, Mumbai, Overseas..."
                                    className={`w-full bg-[#f8fafc] border-2 ${cityError ? 'border-red-400 ring-4 ring-red-50' : 'border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50'} rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm`}
                                />
                                {cityError && (
                                    <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5">
                                        <FiAlertCircle className="w-3.5 h-3.5" />
                                        Destination city is required.
                                    </p>
                                )}
                            </div>
                        </div>
                    )}

                    <div className="space-y-2">
                        <label className="block text-[13px] font-bold text-gray-700 ml-1">Detailed Reason</label>
                        <textarea
                            value={reason}
                            onChange={(e) => {
                                setReason(e.target.value);
                                if (e.target.value.trim().length > 0) setReasonError(false);
                            }}
                            placeholder="Briefly describe the purpose of your leave..."
                            className={`w-full bg-[#f8fafc] border-2 ${reasonError ? 'border-red-400 ring-4 ring-red-50' : 'border-gray-100 focus:border-[#133A69] focus:ring-4 focus:ring-blue-50'} rounded-2xl px-5 py-4 text-sm outline-none text-gray-700 transition-all font-semibold shadow-sm min-h-[120px] resize-y`}
                        ></textarea>
                        {reasonError && (
                            <p className="text-[11px] text-red-500 font-bold mt-2 ml-1 flex items-center gap-1.5">
                                <FiAlertCircle className="w-3.5 h-3.5" />
                                Please specify the reason for your visit.
                            </p>
                        )}
                    </div>

                    <div className="flex flex-col sm:flex-row items-center gap-4 pt-6">
                        <button
                            type="submit"
                            disabled={loading}
                            className="flex-[2] w-full bg-[#133A69] hover:bg-[#0c2545] text-white font-black py-4 px-8 rounded-2xl flex items-center justify-center gap-3 transition-all shadow-xl shadow-blue-900/10 active:scale-[0.98] disabled:opacity-70 disabled:cursor-not-allowed group"
                        >
                            {loading ? (
                                <div className="w-6 h-6 border-3 border-white/20 border-t-white rounded-full animate-spin"></div>
                            ) : (
                                <>
                                    <span>Submit Application</span>
                                    <FiFileText className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                                </>
                            )}
                        </button>
                        <button
                            type="button"
                            onClick={onBack}
                            className="flex-1 w-full px-8 py-4 bg-white border-2 border-gray-100 text-gray-500 font-bold rounded-2xl hover:bg-gray-50 hover:text-gray-700 transition-all active:scale-[0.98]"
                        >
                            Discard
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default AdvanceLeave;
